module.exports = "<router-outlet>\r\n\r\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main